module.exports = __webpack_public_path__ + "static/media/megali-paraskeui-writer.68da6a65.jpg";